'use strict';
import { cn_svg_map} from './cn_svg_map';
import { cn_event_handler } from './cn_event_handler';
import { cn_camera } from './cn_camera';
import { cn_mouse_event } from './cn_mouse_event';

export class cn_space_selection_handler extends cn_event_handler {
    //***********************************************************************************
    /** A handler that manages space selection.
     * Constructor
     * @param {cn_svg_map} map
     */
    constructor(map) {
        super(map);

        this._map = map;
        this._scene = map._scene;
        this.spaces = [];
        this.authorized_spaces = this._scene.spaces;

        this._mouseover_space = null;
    }

    select_all_spaces() {
        if (this.spaces.length < this.authorized_spaces.length)
            this.spaces = this.authorized_spaces.concat([]);
        else 
            this.spaces = [];
    }
    //***********************************************************************************
    //**** Draws
    //***********************************************************************************
    
    /**
     * Draws in svg
     * @param {cn_camera} camera
     * @returns {string}
     */
    draw(camera) {
        let html = "";
        this.spaces.forEach(sp => 
            html += camera.draw_styled_polygon(sp.inner_polygon,"fill: rgba(255, 136, 0,0.3); stroke: none")
        );

        if (this._mouseover_space) 
            html += camera.draw_styled_polygon(this._mouseover_space.inner_polygon,"stroke: rgb(255, 136, 0); fill: none; stroke-width: 4px");
        return html;
    }

    /**
     * Manage a passive move. To return 'true' if something of interest under the mouse.
     * @param {cn_mouse_event} mouse_event
     * @returns  {boolean}
     */
    move(mouse_event) {
        this._mouseover_space = this._scene.find_space(mouse_event.mouse_world,0);
        if (this._mouseover_space && !this.authorized_spaces.includes(this._mouseover_space))
            this._mouseover_space = null;
        return true;
    }

    /**
     * Manage a click. Only after a grab that returned true, and no drag. To return 'true' if click had an effect.
     * @param {cn_mouse_event} mouse_event
     * @returns {boolean}
     */
    click(mouse_event) {
        this.move(mouse_event);
        if (this._mouseover_space) {
            let index = this.spaces.indexOf(this._mouseover_space);
            if (index >= 0)
                this.spaces.splice(index,1);
            else
                this.spaces.push(this._mouseover_space);
            return true;
        }
        return false;
    }

}
